module.exports = __webpack_public_path__ + "img/aeroland-digital-store-product-01.2d0482ed.jpg";